import { render, staticRenderFns } from "./PageOperations.vue?vue&type=template&id=2147ee5c&"
import script from "./PageOperations.vue?vue&type=script&lang=js&"
export * from "./PageOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports